import React from 'react';
import { SearchIcon, GlobeIcon, MenuIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" role="banner" data-id="element-165">
      {/* Top Utility Bar */}
      <div className="bg-[#002D62] text-white" data-id="element-166">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-center gap-x-6 gap-y-1 text-xs sm:text-sm flex-wrap" data-id="element-167">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1" data-id="element-168">
            <a href="https://maps.google.com/?q=8700+Central+Ave+%23302A+Landover+MD+20785" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 hover:text-white/80 transition-colors underline-offset-2 hover:underline" data-id="element-169">
              <MapPinIcon className="h-3.5 w-3.5 flex-shrink-0" data-id="element-170" />
              Landover
            </a>
            <a href="tel:3016139295" className="flex items-center gap-1.5 hover:text-white/80 transition-colors" data-id="element-171">
              <PhoneIcon className="h-3.5 w-3.5 flex-shrink-0" data-id="element-172" />
              (301) 613-9295
            </a>
            <a href="https://maps.google.com/?q=6188+Oxon+Hill+Rd+%23601+Oxon+Hill+MD+20745" target="_blank" rel="noopener noreferrer" className="hidden lg:flex items-center gap-1.5 hover:text-white/80 transition-colors underline-offset-2 hover:underline" data-id="element-173">
              <MapPinIcon className="h-3.5 w-3.5 flex-shrink-0" data-id="element-174" />
              Oxon Hill
            </a>
            <a href="tel:2405537993" className="hidden lg:flex items-center gap-1.5 hover:text-white/80 transition-colors" data-id="element-175">
              <PhoneIcon className="h-3.5 w-3.5 flex-shrink-0" data-id="element-176" />
              (240) 553-7993
            </a>
          </div>
          <button className="flex items-center gap-1 font-semibold hover:text-white/80 transition-colors" aria-label="Toggle Language" data-id="element-177">
            <GlobeIcon className="h-3.5 w-3.5" data-id="element-178" />
            EN | ES
          </button>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="bg-[#0A71B1] text-white" data-id="element-179">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
          <div className="flex justify-between items-center h-16 md:h-20" data-id="element-181">
            {/* Logo */}
            <a href="/" className="flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px]" data-id="element-182">
              <img src="https://cdn.magicpatterns.com/uploads/s899UuCsAYeWwVHcPPvFSS/healthy_choice_logo.png" alt="Healthy Choice Family Clinic & Urgent Care" className="h-12 md:h-14 w-auto object-contain" data-id="element-183" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-5 lg:gap-7" aria-label="Main Navigation" data-id="element-184">
              <a href="/" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-185">
                Home
              </a>
              <a href="/#about" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-186">
                About
              </a>
              <a href="/#services" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-187">
                Services
              </a>
              <a href="/team" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-188">
                Our Team
              </a>
              <a href="/blog" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-189">
                Blog
              </a>
              <a href="/careers" className="text-base font-semibold text-white hover:text-white/80 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-[10px] px-2 py-1" data-id="element-190">
                Careers
              </a>
            </nav>

            {/* Actions */}
            <div className="flex items-center gap-2 md:gap-3" data-id="element-191">
              <button className="flex items-center justify-center h-12 w-12 rounded-[10px] text-white hover:bg-white/15 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Search" data-id="element-192">
                <SearchIcon className="h-5 w-5" data-id="element-193" />
              </button>

              <a href="/book" className="hidden md:flex items-center justify-center bg-[#E8891D] hover:bg-[#d07a15] text-white px-6 py-2.5 rounded-full text-base font-semibold transition-colors min-h-[48px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#0A71B1]" data-id="element-194">
                Book Appointment
              </a>

              <button className="md:hidden flex items-center justify-center h-12 w-12 rounded-[10px] text-white hover:bg-white/15 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" aria-label="Open Menu" data-id="element-195">
                <MenuIcon className="h-6 w-6" data-id="element-196" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}